'use client';
import React from 'react';
import { Button, Div, Text } from '@pezeshk-book/ui-kit';
import Image from '@elements/image';
import { PostItemProps } from '../../posts.props';
import routes from '@routes';
import Link from 'next/link';
import PostItemSchema from '@schema/post/post-item';
import getParseRoute from '@utils/helpers/parse-route';
import { useParams } from 'next/navigation';
import { LocaleTypes } from '@dictionaries-types';

const PostItemDesktop = ({ slug, publishedAt, subtitle, image = '/images/default.jpg', title }: PostItemProps) => {
  const { lang } = useParams<{lang: LocaleTypes}>();
  return (
    <Link passHref={true} href={getParseRoute({ pathname: routes['route.posts.show'], query: { slug: slug }, locale: lang })}>
      <Div className={'flex-col relative items-center justify-between mx-2 w-52'} itemScope itemType="https://schema.org/BlogPosting">
        <Div className={'flex-col relative items-center justify-between w-52'}>
          <Div className={'group block relative w-full h-72 z-[7] justify-center items-center overflow-hidden'}>
            <Image itemProp={'image'} className={'object-cover bg-white rounded-t-xl'} src={image} alt={`تصویر ${title}`}/>
            <Div className={'duration-300 transition-all translate-y-48 -translate-x-52 group-hover:translate-y-0 group-hover:translate-x-0 flex-col w-full h-48 py-4 self-end absolute rounded-tr-3xl items-center bg-control/60'}>
              <Div className={'text-center mt-2 px-4 overflow-hidden'}>
                <Text align={'right'} typography={'sm'} color={'white'}>
                  {subtitle}
                </Text>
              </Div>
            </Div>
          </Div>
          <Button
            size={'small'}
            fontType={'bold'}
            className={'rounded-t-none overflow-hidden w-full px-4 z-[8] whitespace-nowrap text-ellipsis'}>
            {title}
          </Button>
        </Div>
        <PostItemSchema
          slug={slug}
          publishedAt={publishedAt}
          image={image}
        />
      </Div>
    </Link>
  );
};

export default PostItemDesktop;
